import React, { useEffect, useState } from 'react';
import { isAppInstalled } from '../../../utils/userAgentInfoUtils';
import { trackAppDownloadBannerClicked, trackAppDownloadBannerLoad } from '../../../utils/omnitureUtils';
import '../../../styles/AppDownload.css';

interface AppDownloadProps {
  data: {
    text: string;
    subtext: string;
    ctaOpenAppText: string;
    ctaDefaultText: string;
    ctaDeeplink: string;
  };
}

function AppDownload({ data }: AppDownloadProps) {
  const [isAppInstalledAlready, setIsAppInstalledAlready] = useState(false);

  const handleOmniture = async () => {
    const checkAppInstalled = (await isAppInstalled()) || false;
    setIsAppInstalledAlready(checkAppInstalled);
    trackAppDownloadBannerLoad(`big_${checkAppInstalled ? 'appopen' : 'appdownload'}_topstrip_shown`);
  };

  useEffect(() => {
    handleOmniture();
  }, []);

  const isButtonClicked = () => {
    if (data?.ctaDeeplink) {
      window.open(data?.ctaDeeplink, '_blank');
    }
    trackAppDownloadBannerClicked(`big_${isAppInstalledAlready ? 'appopen' : 'appdownload'}_topstrip_clicked`);
  };

  return (
    <div className="appDownloadContainer">
      <div className="makeFlex hrtlCenter appendBottom12">
        <span className="appDownloadSprite appdownloadIcon appendRight15"></span>
        <div>
          <p className="font14 lineHeight20 latoBold blackText">{data?.text}</p>
          <p className="font12 lineHeight16 darkGreyText">{data?.subtext}</p>
        </div>
      </div>
      <button type="submit" className="appDownloadButton" onClick={isButtonClicked}>
        {isAppInstalledAlready ? data?.ctaOpenAppText : data?.ctaDefaultText}
      </button>
    </div>
  );
}

export default AppDownload;
